import { Pipe, PipeTransform, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  transform(value: string): any {
    let datePipe = new DatePipe('en-US');
    if (value.split('T')[0] == new Date().toISOString().split('T')[0]) {
      return datePipe.transform(value, "hh:mm a")
    }
    else if (datePipe.transform(value, "y") != new Date().getFullYear().toString()) {
      return datePipe.transform(value, "d/M/yy");
    }
    else {
      return datePipe.transform(value, "MMM d");
    }
  }
}

@NgModule({
  declarations: [FormatDatePipe],
  exports: [FormatDatePipe]
})
export class FormatDatePipeModule {
}
